<div class="suspended-license-page-container container" [formGroup]="form">
  <p>{{ 'suspendedLicensePage.description' | translate }}</p>

  <mat-form-field class="default-field-width">
    <mat-select formControlName="suspendedReason" [placeholder]="'suspendedLicensePage.reason' | translate" required>
      <mat-option value="ABUSE">{{ 'suspendedLicensePage.reasons.abuse' | translate }}</mat-option>
      <mat-option value="NON_PAYMENT">{{ 'suspendedLicensePage.reasons.nonPayment' | translate }}</mat-option>
      <mat-option value="OTHER">{{ 'suspendedLicensePage.reasons.other' | translate }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mtn-text-area-field [form]="form" controlName="suspendedComment"
                       [placeholder]="'suspendedLicensePage.comment' | translate">
  </mtn-text-area-field>
</div>
